import { onlyDigitsNumbers } from "../../common/components/TemplateContainer/InputTemplates";
import {
  CheckboxSection,
  Container,
  InputSection,
} from "./RequestedInputStyles";

function CheckableInput(props) {
  const {
    value,
    onChangeValue,
    placeholder,
    checked,
    onChangeCheck,
    hasError,
    disabled,
    maxLength,
  } = props;

  return (
    <Container
      height={props.height}
      width={props.width}
      checked={checked}
      hasError={hasError}
      disabled={disabled}
    >
      <InputSection
        onKeyPress={onlyDigitsNumbers}
        value={value}
        placeholder={placeholder}
        onChange={onChangeValue}
        checked={checked}
        readOnly={checked}
        disabled={disabled}
        maxLength={maxLength ? maxLength : 40}
      />
      <CheckboxSection
        checked={checked}
        type="checkbox"
        onChange={onChangeCheck}
        disabled={disabled}
      />
    </Container>
  );
}

export default CheckableInput;
